import { StoreCoverageDetailInformationContainer } from "../";

export const StoreCoverageDetailMainContainer = () => {
  return (
    <div className="productDetailMainContainer">
      <StoreCoverageDetailInformationContainer />
    </div>
  );
};
